import { Component, OnInit } from '@angular/core';
import mockedAixmCatalogue from './../mocked-aixm-catalogue.json';
import {ActivatedRoute} from "@angular/router";
import { LockDialogComponent } from '../dialogs/property-access-rights-dialog/lock-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { BusinessRuleDialogComponent } from '../dialogs/property-business-rule/business-rule.component';

@Component({
    selector: 'property-view',
    templateUrl: './property-view.component.html',
    styleUrls: ['./property-view.component.css']
})
export class PropertyViewComponent implements OnInit {
    propertyName: string;
    propertyGroupName: string;
    featureName: string;
    metadataExpanded: boolean = false;
    matchingProperty: any;

    constructor(private route: ActivatedRoute, private dialog: MatDialog) {}

    toggleMetadata(): void {
        this.metadataExpanded = !this.metadataExpanded;
    }

    findPropertyMatch(): void {
        const matchingGroup = mockedAixmCatalogue?.schema?.group?.find((el) => el?._name === this.propertyGroupName);
        console.log('MG: ', matchingGroup);
        if (matchingGroup) {
            // @ts-ignore
            const matchingProperty = matchingGroup?.sequence?.element?.find((el) => el?._name === this.propertyName);
            if (matchingProperty) {
                this.matchingProperty = matchingProperty;
            }
        }
    }

    ngOnInit() {
        this.featureName = this.route.snapshot.paramMap.get('featureId');
        this.propertyGroupName = this.route.snapshot.paramMap.get('propertyGroupId');
        this.propertyName = this.route.snapshot.paramMap.get('propertyId');

        this.route.paramMap.subscribe(params => {
            this.featureName = params.get('featureId');
            this.propertyGroupName = params.get('propertyGroupId');
            this.propertyName = params.get('propertyId');
        });
        this.findPropertyMatch();
    }
openLockDialog() {
  const dialogRef = this.dialog.open(LockDialogComponent, {
    width: '1000px',
    data: {
      propertyName: this.propertyName,
      propertyGroupName: this.propertyGroupName
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    console.log('Dijalog zatvoren, rezultat:', result);
  });
}
openBusinessRuleDialog() {
  const dialogRef = this.dialog.open(BusinessRuleDialogComponent, {
    width: '1000px',
    height: '800px',

    data: {
      propertyName: this.propertyName,
      propertyGroupName: this.propertyGroupName
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    console.log('Dijalog zatvoren, rezultat:', result);
  });
}

  save(): void {
    // TODO: ovdje implementiraj logiku snimanja
    console.log("Save icon clicked");
    // npr. poziv servisa ili API-ja
    // this.featureService.save(this.matchingFeature).subscribe(...)
  }
}